module.exports = __webpack_public_path__ + "static/media/OurWork.43fdf5e2.svg";